export const type= 'MENU-CONTROLLER'
const   MenuController = (open)=>({
    type,
    open
})
export default MenuController